/** Ticker Intelligence Workspace. Presentation only — data arrives already
 * mapped. Production Strategy Tools remains /ticker/:symbol.
 */
import { useState } from "react";
import { Tabs, TabsContent } from "@/components/ui/tabs";
import { TabStrip } from "@/workspace/primitives";
import { WorkspaceSelectionProvider } from "@/workspace/selection";
import { WorkspaceHandoffProvider } from "@/workspace/handoffContext";
import { TickerHeader } from "@/workspace/TickerHeader";
import { OverviewTab } from "@/workspace/tabs/OverviewTab";
import { OptionsIncomeHedgingTab } from "@/workspace/tabs/OptionsIncomeHedgingTab";
import { TechnicalsTab } from "@/workspace/tabs/TechnicalsTab";
import { RegimeTab } from "@/workspace/tabs/RegimeTab";
import { FundamentalsTab } from "@/workspace/tabs/FundamentalsTab";
import { EarningsTab } from "@/workspace/tabs/EarningsTab";
import { TickerTalkTab } from "@/workspace/tabs/TickerTalkTab";
import { OwnershipTab } from "@/workspace/tabs/OwnershipTab";

export const WORKSPACE_TABS = [
  { value: "overview", label: "Overview", Panel: OverviewTab },
  { value: "regime", label: "Regime", Panel: RegimeTab },
  { value: "options", label: "Options Income & Hedging", Panel: OptionsIncomeHedgingTab },
  { value: "technicals", label: "Technicals", Panel: TechnicalsTab },
  { value: "fundamentals", label: "Fundamentals", Panel: FundamentalsTab },
  { value: "earnings", label: "Earnings & Estimates", Panel: EarningsTab },
  { value: "talk", label: "Ticker Talk", Panel: TickerTalkTab },
  { value: "ownership", label: "Ownership & Disclosures", Panel: OwnershipTab },
];

export function TickerWorkspace({
  ticker,
  defaultTab = "overview",
  tab: tabProp,
  onTabChange,
  initialExpiry,
  initialStrategy,
  handoff,
}) {
  const [tabInner, setTab] = useState(defaultTab);
  const tab = tabProp ?? tabInner;

  const changeTab = (next) => {
    if (tabProp == null) setTab(next);
    if (onTabChange) onTabChange(next);
  };

  return (
    <WorkspaceHandoffProvider value={handoff}>
    <WorkspaceSelectionProvider
      ticker={ticker}
      initialExpiry={initialExpiry}
      initialStrategy={initialStrategy}
    >
      <div className="space-y-3 min-w-0" data-testid="ticker-workspace">
        <div className="md:sticky md:top-0 md:z-10" style={{ background: "var(--hoip-bg)" }}>
          <TickerHeader t={ticker} />
        </div>

        <Tabs value={tab} onValueChange={changeTab}>
          <TabStrip tabs={WORKSPACE_TABS} value={tab} testid="workspace-tabs" />

          {WORKSPACE_TABS.map(({ value, Panel }) => (
            <TabsContent key={value} value={value} className="mt-3 min-w-0" data-testid={`workspace-panel-${value}`}>
              <Panel t={ticker} />
            </TabsContent>
          ))}
        </Tabs>
      </div>
    </WorkspaceSelectionProvider>
    </WorkspaceHandoffProvider>
  );
}
